module.exports = __webpack_public_path__ + "media/bootstrap-icons/collection-play-78d9f816.svg";